import { render, staticRenderFns } from "./LicenseOverview.vue?vue&type=template&id=96949d2a&"
import script from "./LicenseOverview.vue?vue&type=script&lang=js&"
export * from "./LicenseOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports